const createIdealSource = (stripe, options = {}) => {
  const {
    amount = 1,
    currency = 'eur',
    returnUrl = `${window.location.origin}/payment-method/ideal/callback`,
    bank = null,
  } = options;

  const sourceData = {
    type: 'ideal',
    amount,
    currency,
    ideal: {
      bank,
    },
    redirect: {
      return_url: returnUrl,
    },
  };

  return stripe.createSource(sourceData);
};

export default createIdealSource;
